module.exports = __webpack_public_path__ + "img/zgjienengwang.bf5a6620.png";